import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Header from './header'
import Login from './login'
import Logout from './logout'
import Reminder from './reminder'
import Top from './top'
import Menu from './menu'
import Dialog from './dialog'
import Error from './error'
import ChangePassword from './change-password'
import Code from './code'
import AccountEntry from './account/entry'
import AccountChange from './account/change'
import TermsOfUse from './account/terms-of-use'
import AdminMstGroup from './admin/mst/group'
import AdminMstCompany from './admin/mst/company'
import AdminMstBranch from './admin/mst/branch'
import AdminMstService from './admin/mst/service'
import AdminAccount from './admin/account'
import GroupAccount from './group/account'
import GroupAccountEntry from './group/account-entry'
import AdminSendMail from './admin/sendmail'
import AccountChangegroup from './admin/accountchangegroup'
import SearchCompanyDialog from './search-company-dialog'

Vue.use(VueI18n)

const messages = {
  ja: {
    message: {
      header: Header.jp,
      login: Login.jp,
      logout: Logout.jp,
      reminder: Reminder.jp,
      top: Top.jp,
      menu: Menu.jp,
      dialog: Dialog.jp,
      error: Error.jp,
      changePassword: ChangePassword.jp,
      code: Code.jp,
      searchCompanyDialog: SearchCompanyDialog.jp,
      account: {
        entry: AccountEntry.jp,
        change: AccountChange.jp,
        termsOfUse: TermsOfUse.jp
      },
      admin: {
        account: AdminAccount.jp,
        accountchangegroup: AccountChangegroup.jp,
        mst: {
          group: AdminMstGroup.jp,
          company: AdminMstCompany.jp,
          branch: AdminMstBranch.jp,
          service: AdminMstService.jp
        },
        sendmail: AdminSendMail.jp
      },
      group: {
        account: GroupAccount.jp,
        accountEntry: GroupAccountEntry.jp
      }
    }
  },
  en: {
    message: {
      header: Header.en,
      login: Login.en,
      logout: Logout.en,
      reminder: Reminder.en,
      top: Top.en,
      menu: Menu.en,
      dialog: Dialog.en,
      error: Error.en,
      changePassword: ChangePassword.en,
      code: Code.en,
      searchCompanyDialog: SearchCompanyDialog.en,
      account: {
        entry: AccountEntry.en,
        change: AccountChange.en,
        termsOfUse: TermsOfUse.en
      },
      group: {
        account: GroupAccount.en,
        accountEntry: GroupAccountEntry.en
      },
      // admin配下は英語不要
      admin: {
        account: AdminAccount.jp,
        accountchangegroup: AccountChangegroup.jp,
        mst: {
          group: AdminMstGroup.jp,
          company: AdminMstCompany.jp,
          branch: AdminMstBranch.jp,
          service: AdminMstService.jp
        },
        sendmail: AdminSendMail.jp
      }
    }
  }
}

const i18n = new VueI18n({
  locale: 'ja',
  messages
})

export default i18n
